import {
  CA_FETCH_COST_BY_CONTROL_ACCOUNT_BEGIN,
  CA_FETCH_COST_BY_CONTROL_ACCOUNT_SUCCESS,
  CA_FETCH_COST_BY_CONTROL_ACCOUNT_FAILURE,
  CA_FETCH_COST_BY_CONTROL_ACCOUNT_DISMISS_ERROR,
} from './constants';



import {SERVER_PATH, AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchCostByControlAccount(control_account, cost_type ,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CA_FETCH_COST_BY_CONTROL_ACCOUNT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      
      axios.get(SERVER_PATH +'/costs/getCostByControlAccount/' + control_account + "/" + cost_type, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success ===1)
          {
            dispatch({
              type: CA_FETCH_COST_BY_CONTROL_ACCOUNT_SUCCESS,
              data: res.data.cost,
            });
            resolve(res.data);
          }else
          {
            dispatch({
              type: CA_FETCH_COST_BY_CONTROL_ACCOUNT_FAILURE,
              data: { error: "Internal error" },
            });
            reject("Internal error");
          }

        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CA_FETCH_COST_BY_CONTROL_ACCOUNT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchCostByControlAccountError() {
  return {
    type: CA_FETCH_COST_BY_CONTROL_ACCOUNT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CA_FETCH_COST_BY_CONTROL_ACCOUNT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchCostByControlAccountPending: true,
        fetchCostByControlAccountError: null,
      };

    case CA_FETCH_COST_BY_CONTROL_ACCOUNT_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchCostByControlAccountPending: false,
        fetchCostByControlAccountError: null,
      };

    case CA_FETCH_COST_BY_CONTROL_ACCOUNT_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchCostByControlAccountPending: false,
        fetchCostByControlAccountError: action.data.error,
      };

    case CA_FETCH_COST_BY_CONTROL_ACCOUNT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchCostByControlAccountError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/fetchCostByControlAccount.js